import { InfoButton } from 'components/buttons'
import { ageNextBirthday } from 'lib/date'
import { SectionHeading } from 'components/headings'
import Image from 'components/image'
import Slide from '../../components/slide/slide'
import { useNavigate } from 'react-router-dom-v5-compat'
import useMaxWishlistBirthdate from 'registry/modules/registry-builder/hooks/useMaxWishlistBirthdate'

interface CelebrateAgeProps {
  birthdate: string
  nextPath: string
}

export const CelebrateAge = ({ birthdate, nextPath }: CelebrateAgeProps) => {
  const navigate = useNavigate()
  const { allowFutureBirthdates } = useMaxWishlistBirthdate()
  const nextAge = ageNextBirthday(birthdate)
  const isNotBornYet = allowFutureBirthdates && nextAge === 0
  const age = isNotBornYet ? 'newborn' : `${nextAge} year old`

  const handleNext = () => {
    navigate(nextPath)
  }

  return (
    <Slide>
      <Image
        role="presentation"
        src="//images.babylist.com/image/upload/v1696269967/cupcake_oxba1u.svg"
        width="150px"
      />
      <SectionHeading
        className="text-center"
        style={{ maxWidth: 600, marginTop: 0 }}
      >
        Congratulations, you'll have a {age} on your hands soon!
      </SectionHeading>
      {!isNotBornYet && <p>They grow up so fast!</p>}
      <InfoButton
        pill
        className="mtl"
        style={{ minWidth: 230 }}
        onClick={handleNext}
      >
        Next
      </InfoButton>
    </Slide>
  )
}
